import './home-usdt.scss';

import React, { FunctionComponent, useEffect, useState } from "react";
import { LineChart, Line,XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { formatNumberBR } from '../../utils/format';

export interface Kline {
  openTime: number;
  open: number;
  high: number;
  low: number;
  close: number;
}

const HomeUsdt: FunctionComponent = () => {

    const [data, setData] = useState<Kline[]>([]);
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                const res = await fetch(
                    'https://api.binance.com/api/v3/klines?symbol=USDTBRL&interval=5m&limit=288'
                );

                const rawData = await res.json();

                const formatted: Kline[] = rawData.map((k: any) => ({
                    openTime: k[0],
                    open: Number(k[1]),
                    high: Number(k[2]),
                    low: Number(k[3]),
                    close: Number(k[4]),
                }));

                setData(formatted);
            } catch (error) {
                console.error('Error fetching Binance data', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return <p>Carregando gráfico...</p>;
    }

    return (
        <div className="home-uast">
            <div className="chart-subtitle flex sb">
                <small>USDT x BRL — intervalo 5 mins</small>
                <div className="value flex middle">
                    Valor Atual:
                    <b>
                        { formatNumberBR(data[data.length-1].close) }
                    </b>
                </div>
            </div>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                    <defs>
                        <linearGradient id="usdtStroke" x1="0" y1="0" x2="1" y2="0">
                            <stop offset="0%"   stopColor="#16dcec" />
                            <stop offset="100%" stopColor="#483fc5" />
                        </linearGradient>
                    </defs>
                    <XAxis
                        dataKey="openTime"
                        tick={{ fill: "#a39fe2", fontSize: 11 }}
                        axisLine={{ stroke: "#7f79d633" }}
                        tickLine={{ stroke: "#7f79d633" }}
                        tickFormatter={(t) =>
                            new Date(t).toLocaleTimeString('pt-BR', {
                                hour: '2-digit',
                                minute: '2-digit',
                            })
                        }
                    />
                    <YAxis
                        domain={['auto', 'auto']}
                        tick={{ fill: "#a39fe2", fontSize: 11 }}
                        axisLine={{ stroke: "#7f79d633" }}
                        tickLine={{ stroke: "#7f79d633" }}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "rgba(15, 15, 58, 0.95)",
                            border: "1px solid rgba(22, 220, 236, 0.35)",
                            borderRadius: "10px",
                            color: "#f2f2f2",
                            backdropFilter: "blur(8px)",
                        }}
                        labelStyle={{ color: "#a39fe2", fontSize: 11, textTransform: "uppercase", letterSpacing: 1 }}
                        itemStyle={{ color: "#16dcec", fontWeight: 600 }}
                        labelFormatter={(t) =>
                            new Date(t).toLocaleString('pt-BR')
                        }
                    />
                    <Line
                        type="monotone"
                        dataKey="close"
                        stroke="url(#usdtStroke)"
                        strokeWidth={2.5}
                        dot={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default HomeUsdt;